// 会社案内の写真カルーセル。自動送り・矢印・ドット。
// 依存なし。prefers-reduced-motion と hover/focus 中は自動送りを止める。
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    var track = root.querySelector('[data-w99-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-w99-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-w99-dot]'));
    if (slides.length < 2) {
      var ui = root.querySelector('.w99-carousel-ui');
      if (ui) ui.hidden = true;
      return;
    }
    var index = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5200;
    var paused = false;

    function mark(n) {
      index = n;
      dots.forEach(function (d, k) {
        if (k === n) { d.setAttribute('aria-current', 'true'); }
        else { d.removeAttribute('aria-current'); }
      });
    }

    function go(n, smooth) {
      var len = slides.length;
      var next = ((n % len) + len) % len;
      track.scrollTo({
        left: slides[next].offsetLeft - slides[0].offsetLeft,
        behavior: (smooth && !reduce) ? 'smooth' : 'auto'
      });
      mark(next);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduce || paused) return;
      timer = setInterval(function () {
        if (document.hidden) return;
        go(index + 1, true);
      }, interval);
    }

    root.querySelector('[data-w99-next]').addEventListener('click', function () { go(index + 1, true); start(); });
    root.querySelector('[data-w99-prev]').addEventListener('click', function () { go(index - 1, true); start(); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k, true); start(); });
    });

    ['pointerenter', 'focusin'].forEach(function (ev) {
      root.addEventListener(ev, function () { paused = true; stop(); });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      root.addEventListener(ev, function () {
        if (root.contains(document.activeElement)) return;
        paused = false; start();
      });
    });

    // 指やトラックパッドで動かしたときはドットを追従させる
    var settle = null;
    track.addEventListener('scroll', function () {
      if (settle) clearTimeout(settle);
      settle = setTimeout(function () {
        var base = slides[0].offsetLeft;
        var near = 0, best = Infinity;
        slides.forEach(function (s, k) {
          var d = Math.abs((s.offsetLeft - base) - track.scrollLeft);
          if (d < best) { best = d; near = k; }
        });
        mark(near);
      }, 120);
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1, true); }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    mark(0);
    start();
  }

  function init() {
    document.querySelectorAll('[data-w99-carousel]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
